import { MapPin } from "lucide-react";

const ZONAS = [
  "Valencia capital", "Torrent", "Aldaia", "Paiporta", "Paterna",
  "Mislata", "Sagunto", "Manises", "Burjassot", "Catarroja", "Alboraya",
];

export default function Zones() {
  return (
    <section className="bg-slate-50/60 border-y border-slate-200 scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-5">
            <div className="inline-flex items-center gap-2 text-[#004B87] text-[11px] uppercase tracking-[0.2em] font-semibold mb-3">
              <MapPin className="w-3.5 h-3.5" /> Zona de trabajo
            </div>
            <h2 className="font-display font-semibold text-2xl md:text-3xl text-slate-900 tracking-tight">
              Trabajamos en Valencia y provincia
            </h2>
            <p className="text-slate-600 mt-3 text-sm leading-relaxed">
              Prestamos servicio en Valencia capital y alrededores. Si tu zona no aparece en la lista, escríbenos por WhatsApp y lo valoramos.
            </p>
          </div>
          <div className="md:col-span-7 flex flex-wrap gap-2">
            {ZONAS.map(z => (
              <span
                key={z}
                data-testid={`zone-${z.replace(/\s+/g, '-').toLowerCase()}`}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border border-slate-200 text-sm text-slate-700 hover:border-[#004B87] hover:text-[#004B87] transition-colors"
              >
                <MapPin className="w-3 h-3 text-[#004B87]" /> {z}
              </span>
            ))}
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#004B87]/10 border border-[#004B87]/20 text-sm text-[#004B87] font-medium">
              y otras zonas de la provincia
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
